var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBannerLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 3V29C40 30.3807 38.8807 31.5 37.5 31.5H3.73703C1.74029 31.5 0.549316 29.2746 1.65691 27.6133L8.84438 16.8321C9.18027 16.3282 9.18027 15.6718 8.84437 15.168L1.65691 4.38675C0.549316 2.72536 1.7403 0.5 3.73703 0.5H37.5C38.8807 0.5 40 1.61929 40 3Z",
    fill: "#022131",
    stroke: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerLeft);
export default __webpack_public_path__ + "static/media/banner-left.b44ce88a6fee3121ded610fb608a2fb3.svg";
export { ForwardRef as ReactComponent };